import useSitecoreContext from '../hooks/useSitecoreContext';

function useAppendRootToInternalLink(link?: string) {
  const {sitecoreContext} = useSitecoreContext();
  const hostAppRoot: string | undefined = sitecoreContext?.hostAppRoot;
  if (!link || !hostAppRoot || !link.startsWith('/')) return link;

  const baseUrl: string = hostAppRoot.endsWith('/') ? hostAppRoot.slice(0, -1) : hostAppRoot;
  return `${baseUrl}${link}`;
}

export { useAppendRootToInternalLink as appendRootToInternalLink };
